import { memo, useState } from "react";
import "Components/Dashboards/SupportDashboard/SupportDashboard.less";
import type { UserResource } from "Interfaces";
import UserInformation from "Components/Dashboards/SupportDashboard/UserInformation";
import UserTable from "Components/Dashboards/SupportDashboard/UserTable";

function SupportDashboard() {
	const [ selectedUser, setSelectedUser ] = useState<UserResource | null>(null);

	const handleGoBack = () => {
		setSelectedUser(null);
	};

	const handleUserClick = (user: UserResource) => setSelectedUser(user);

	const renderDashboardContent = () => {
		if (selectedUser) {
			return (
				<UserInformation
					selectedUser={ selectedUser }
					onBackClick={ handleGoBack }
				/>
			);
		}

		return <UserTable onUserClick={ handleUserClick } />;
	};

	return (
		<div className="support-dashboard">
			{ renderDashboardContent() }
		</div>
	);
}

export default memo(SupportDashboard);
